
import React from "react";
import { Button } from "@/components/ui/button";
import { Grid2X2, List } from "lucide-react";

interface ViewToggleProps {
  viewMode: "grid" | "list";
  setViewMode: (mode: "grid" | "list") => void;
}

const ViewToggle: React.FC<ViewToggleProps> = ({ viewMode, setViewMode }) => {
  return (
    <div className="flex items-center space-x-2">
      <Button 
        variant={viewMode === "grid" ? "default" : "outline"} 
        size="sm"
        onClick={() => setViewMode("grid")}
        className={viewMode === "grid" ? "bg-eco-500 hover:bg-eco-600" : ""}
      >
        <Grid2X2 className="h-4 w-4 mr-2" />
        Grid
      </Button>
      <Button 
        variant={viewMode === "list" ? "default" : "outline"} 
        size="sm"
        onClick={() => setViewMode("list")}
        className={viewMode === "list" ? "bg-eco-500 hover:bg-eco-600" : ""}
      >
        <List className="h-4 w-4 mr-2" />
        List
      </Button>
    </div>
  );
};

export default ViewToggle;
